<script lang="ts">
  import Home from "./pages/Home.svelte";
  import Router from "svelte-spa-router";
  import Modal from "svelte-simple-modal";

  import { getTransactionFee } from "../services/strapiRestService";

  getTransactionFee()

  const routes = {
    "/": Home,
    "/*": Home,
  };

</script>

<div id="wrapper">
  <Modal closeOnOuterClick={false} classCloseButton="modal-close-button">
    <main id="main">
      <Router {routes} />
    </main>
  </Modal>
</div>
